/**
 * SelectControl - A reusable select dropdown component for WordPress blocks
 *
 * This module exports the SelectControl component along with its related types
 * and utilities for use throughout the Redfox Thank You plugin.
 *
 * @package RedfoxThankYou
 */

// Export the main component
// Import styles (webpack will handle this)
import './style.scss';

export { SelectControl } from './component';

// Export TypeScript interfaces and types
export type { SelectControlProps, SelectOption } from './types';

// Export enums
export { SelectSize, SelectVariant } from './types';
